export default __webpack_public_path__ + "static/media/arrow-down.d09c2df7.svg";